// extracted by mini-css-extract-plugin
module.exports = {"mainBlock":"NewPlaceOriginal_mainBlock__2X3VS","buttonsWrapper":"NewPlaceOriginal_buttonsWrapper__4aV95"};